import Fade from "@mui/material/Fade";
import { Button, Stack } from "@mui/material";
import { Header } from "../SignUp/partials/Header";
import { Footer } from "../SignUp/partials/Footer";
import { Container } from "../SignUp/partials/Container";
import { useState } from "react";
import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { SetNewPasswordForm } from "./partials/SetNewPasswordForm";

const SetNewPassword = () => {
  const [resetPassword, setResetPassword] = useState(false);

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get("token");

  return !token ? (
    <Navigate to="/login" />
  ) : (
    <Container>
      <Fade in={resetPassword} timeout={1000}>
        <Stack
          width="100%"
          alignItems="center"
          display={resetPassword ? "flex" : "none"}
        >
          <Header
            disableCompanyIdentity
            title="Your password has been reset"
            subtitle="You can now log in with your new password"
          />
          <Button variant="text" onClick={() => navigate("/login")}>
            Return to Login
          </Button>
        </Stack>
      </Fade>
      <Fade in={!resetPassword} timeout={1000}>
        <Stack width="100%" display={!resetPassword ? "flex" : "none"}>
          <Header
            disableCompanyIdentity
            title="Create new password"
            subtitle="Enter your new password below to continue"
          />
          <SetNewPasswordForm
            token={token}
            onSuccess={() => setResetPassword(true)}
          />
          <Footer
            text="Don’t want to set new password?"
            linkText="Sign In"
            link="/login"
          />
        </Stack>
      </Fade>
    </Container>
  );
};

export default SetNewPassword;
